import React from 'react'
import './Spinner.css'

const Spinner = () => {

    
  return (
    <span className="loader"></span>
  )
}

export default Spinner